import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onCreateClick }) => {
  return (
    <div className="bg-card rounded-2xl border border-border p-8 md:p-12 lg:p-16 text-center">
      <div className="max-w-md mx-auto">
        <div className="w-20 h-20 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <Icon name="Globe" size={36} className="text-primary" />
        </div>

        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
          У вас пока нет сайтов
        </h3>

        <p className="text-text-secondary mb-8">
          Создайте свой первый сайт за несколько минут
        </p>

        <Button
          variant="default"
          size="lg"
          iconName="Plus"
          iconPosition="left"
          onClick={onCreateClick}
        >
          Создать первый сайт
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;
